import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { otApprovalListTourSteps } from "./otApprovalListTourSteps";
import { useOvertimeTour } from "./useOvertimeTour";

const TOUR_STORAGE_KEY = "hr-overtime-approval-list-tour-completed";

type OTApprovalListTourProps = {
  run: boolean;
  onCallback: (data: { status?: string; type?: string; index?: number }) => void;
};

export function OTApprovalListTour({ run, onCallback }: OTApprovalListTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type, index: data.index });
  };

  return (
    <Joyride
      steps={otApprovalListTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export function useOTApprovalListTour() {
  return useOvertimeTour(TOUR_STORAGE_KEY);
}
